const CST_PATH_LOGIN = 'login';
const CST_PATH_HOME = 'home';
const CST_PATH_OVERVIEW = 'overview';
const CST_PATH_MYORDERS = 'myorders';
const CST_PATH_DECORTICAGE = 'decorticage';
const CST_PATH_DECORTICAGE_CODE = 'decorticage/:code';
const CST_PATH_SITE_FOLLOW_UP = 'site-follow-up';
const CST_PATH_MY_DELIVERY_NOTE = 'my-delivery-note';
const CST_PATH_MY_CERTIFICATS = 'my-certificats';
const CST_PATH_MY_CERTIFICATS_SHOWBY = 'my-certificats/:showby';
const CST_PATH_MY_INVOICE = 'my-invoice';
// Page employe
const CST_PATH_DASHBOARD_ID = 'dashboard/:id';
const CST_PATH_PRINTING_LIST = 'printing-list';
const CST_PATH_SUPERVISOR = 'supervisor';
const CST_PATH_EVENT_OBSERVER = 'event-observer';
const CST_PATH_STOCK = 'stock';
// Page admin
const CST_PATH_QUERY_EDITOR = 'query-editor';
const CST_PATH_SESSION_MANAGMENT = 'session-managment';
// Sans connexion
const CST_PATH_SHAPES = 'shapes';
// Sans connexion - dédié à la gestion des ticket de support
const CST_PATH_TICKET = 'ticket';
const CST_PATH_TICKET_NUMSOCIETE = 'ticket/:numsociete';
// Autre - Test
const CST_PATH_TRANSLATE = 'translate';
const CST_PATH_DEV = 'dev';

export class RouterPathUtility {

  public static getDecorticageCode(analysisCode: string): string {
    return CST_PATH_DECORTICAGE_CODE.replace(':code', analysisCode);
  }

  public static getCertificateShowBy(showBy: any): string {
    return CST_PATH_MY_CERTIFICATS_SHOWBY.replace(':showby', showBy);
  }

  public static getDashBoardId(id: number): string {
    return CST_PATH_DASHBOARD_ID.replace(':id', id.toString());
  }
}

export const CST_PATH = {
  login: CST_PATH_LOGIN,
  home: CST_PATH_HOME,
  overview: CST_PATH_OVERVIEW,
  myOrders: CST_PATH_MYORDERS,
  decorticage: CST_PATH_DECORTICAGE,
  decorticage_code: CST_PATH_DECORTICAGE_CODE,
  siteFollowUp: CST_PATH_SITE_FOLLOW_UP,
  myDeliveryNote: CST_PATH_MY_DELIVERY_NOTE,
  myCertificats: CST_PATH_MY_CERTIFICATS,
  myCertificats_showBy: CST_PATH_MY_CERTIFICATS_SHOWBY,
  myInvoice: CST_PATH_MY_INVOICE,
  dashboard_id: CST_PATH_DASHBOARD_ID,
  printingList: CST_PATH_PRINTING_LIST,
  supervisor: CST_PATH_SUPERVISOR,
  eventObserver: CST_PATH_EVENT_OBSERVER,
  stock: CST_PATH_STOCK,
  queryEditor: CST_PATH_QUERY_EDITOR,
  sessionManagment: CST_PATH_SESSION_MANAGMENT,
  shapes: CST_PATH_SHAPES,
  ticket: CST_PATH_TICKET,
  ticket_numsociete: CST_PATH_TICKET_NUMSOCIETE,
  translate: CST_PATH_TRANSLATE,
  dev: CST_PATH_DEV,
};

export default CST_PATH;
